(function () {
    'use strict';
    var m = angular.module('troubleshooting');
    m.factory('deploymentStatusLogic', ["$q", "configDao", "modals", "sideMenuManager", function ($q, configDao, modals, sideMenuManager) {
        function formatExpires(value) {
            if (!_(value).isNull()) {
                if (value < 0) {
                    return 'Expired (' + -value + ' days ago)';
                } else {
                    return value + ' days';
                }
            } else {
                return 'never';
            }
        }
        function parseOptionalInt(value) {
            var result = parseInt(value);
            if (!isFinite(result)) {
                result = null;
            }
            return result;
        }
        return function ($scope, logic, reinit) {
            $q.allSettled([
                configDao.getDeploymentStatus(true),
                configDao.param('licenses')
            ]).then(function (responses) {
                var data = {};
                var licenses = '';
                if (responses[0].value) {
                    data = responses[0].value;
                }
                if (responses[1].value) {
                    licenses = responses[1].value;
                    data.licenses = licenses;
                }
                $scope.model.data = [
                    {
                        key: 'Deployment Mode',
                        value: data.deployment_mode
                    },
                    {
                        key: 'Association Date',
                        value: data.association_date
                    },
                    {
                        key: 'POC start date',
                        value: data.poc_start_date
                    },
                    {
                        key: 'POC duration in days',
                        value: parseOptionalInt(data.poc_duration_in_days)
                    },
                    {
                        key: 'POC Expires In (calculated)',
                        value: formatExpires(data.pocExpiresInDays)
                    },
                    {
                        key: 'POC Expiration Date (calculated)',
                        value: data.pocExpirationDate
                    },
                    {
                        key: 'Paid Started',
                        value: data.paid_start
                    },
                    {
                        key: 'Paid Start Date',
                        value: data.paid_start_date
                    },
                    {
                        key: 'Paid duration in days',
                        value: parseOptionalInt(data.paid_duration_in_days)
                    },
                    {
                        key: 'Paid Expires In (calculated)',
                        value: formatExpires(data.paidExpiresInDays)
                    },
                    {
                        key: 'Paid Expiration Date (calculated)',
                        value: data.paidExpirationDate
                    },
                    {
                        key: 'Demo Started',
                        value: data.demo_start
                    },
                    {
                        key: 'Demo Start Date',
                        value: data.demo_start_date
                    },
                    {
                        key: 'Demo duration in days',
                        value: parseOptionalInt(data.demo_duration_in_days)
                    },
                    {
                        key: 'Demo Expires In (calculated)',
                        value: formatExpires(data.demoExpiresInDays)
                    },
                    {
                        key: 'Demo Expiration Date (calculated)',
                        value: data.demoExpirationDate
                    },
                    {
                        key: 'Licenses',
                        value: parseOptionalInt(licenses)
                    },
                    {
                        button: {
                            label: 'Change',
                            'class': 'btn btn-blue',
                            onClick: function () {
                                return modals.params([{
                                        lastPage: true,
                                        params: [
                                            {
                                                id: 'deployment_mode',
                                                type: 'selector',
                                                variants: [
                                                    'poc',
                                                    'paid',
                                                    'demo'
                                                ],
                                                data: data.deployment_mode,
                                                label: 'Deployment Mode'
                                            },
                                            {
                                                id: 'poc_duration_in_days',
                                                type: 'integer',
                                                data: parseOptionalInt(data.poc_duration_in_days),
                                                label: 'POC duration in days',
                                                enabled: {
                                                    param: 'deployment_mode',
                                                    equal: 'poc'
                                                }
                                            },
                                            {
                                                id: 'paid_duration_in_days',
                                                type: 'integer',
                                                data: parseOptionalInt(data.paid_duration_in_days),
                                                label: 'Paid duration in days',
                                                enabled: {
                                                    param: 'deployment_mode',
                                                    equal: 'paid'
                                                }
                                            },
                                            {
                                                id: 'demo_duration_in_days',
                                                type: 'integer',
                                                data: parseOptionalInt(data.demo_duration_in_days),
                                                label: 'Demo duration in days',
                                                enabled: {
                                                    param: 'deployment_mode',
                                                    equal: 'demo'
                                                }
                                            },
                                            {
                                                id: 'licenses',
                                                type: 'integer',
                                                data: parseOptionalInt(licenses),
                                                label: 'Licenses'
                                            }
                                        ]
                                    }], 'Change Deployment Configuration').then(function (newData) {
                                    var dataChanged = false;
                                    var licensesChanged = false;
                                    _(newData).each(function (val, key) {
                                        if (val && !data[key] || !val && data[key] || val && data[key] && val.toString() !== data[key].toString()) {
                                            dataChanged = true;
                                            if (key === 'licenses') {
                                                licensesChanged = true;
                                            }
                                        } else {
                                            delete newData[key];
                                        }
                                    });
                                    if (!dataChanged) {
                                        return;
                                    }
                                    if (newData.deployment_mode === 'paid' && !data.paid_start_date) {
                                        newData.paid_start_date = moment().toJSON();
                                    } else if (newData.deployment_mode === 'demo' && !data.demo_start_date) {
                                        newData.demo_start_date = moment().toJSON();
                                    }
                                    try {
                                        newData.licenses = Math.abs(newData.licenses) || null;
                                    } catch (err) {
                                    }
                                    var queries = _(newData).filter(function (value, param) {
                                        return configDao.setParam(param, value);
                                    });
                                    if (licensesChanged) {
                                        queries.push(configDao.licensesManager());
                                    }
                                    return $q.allSettled(queries).then(function () {
                                        sideMenuManager.updateMenus();
                                        reinit();
                                    }, function (e) {
                                        console.log('Error on saving configs:', e);
                                        sideMenuManager.updateMenus();
                                        reinit();
                                    });
                                });
                            }
                        }
                    }
                ];
            });
            return function () {
            };
        };
    }]);
}());